import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  validate(event) {
    const input = event.target
    if (input.files.length > 10) {
      alert("Você pode inserir no máximo 10 documentos por vez.")
      input.value = null
      return
    }
    for (const file of input.files) {
      if (file.size / 1024 / 1024 > 20) {
        alert("Nenhum documento pode ser superior a 20MB.")
        input.value = null
        return
      }
    }
  }
}
